export default __webpack_public_path__ + "static/media/Stock token for Light Mode.e8519bd4.svg";